// API client for templates, backgrounds, and user state
import { getApiBase } from './apiBase';

const jsonHeaders = { 'Content-Type': 'application/json' };

const json = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`API error ${res.status}: ${text}`);
  }
  return res.json();
};

// ===== Templates =====
export const listTemplates = () =>
  fetch(`${getApiBase()}/templates`, { credentials: 'include' }).then(json);

export const createTemplate = (body) =>
  fetch(`${getApiBase()}/templates`, {
    method: 'POST',
    credentials: 'include',
    headers: jsonHeaders,
    body: JSON.stringify(body),
  }).then(json);

export const updateTemplate = (id, body) =>
  fetch(`${getApiBase()}/templates/${id}`, {
    method: 'PUT',
    credentials: 'include',
    headers: jsonHeaders,
    body: JSON.stringify(body),
  }).then(json);

export const deleteTemplate = (id) =>
  fetch(`${getApiBase()}/templates/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  }).then(json);

export const reorderTemplates = (ids) =>
  fetch(`${getApiBase()}/templates/reorder`, {
    method: 'POST',
    credentials: 'include',
    headers: jsonHeaders,
    body: JSON.stringify({ ids }),
  }).then(json);

// ===== Backgrounds =====
export const listBackgrounds = () =>
  fetch(`${getApiBase()}/backgrounds`, { credentials: 'include' }).then(json);

export const uploadBackground = (file, name, visibility = 'private') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', name || file.name);
  formData.append('visibility', visibility);
  return fetch(`${getApiBase()}/backgrounds`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  }).then(json);
};

export const updateBackground = (id, body) =>
  fetch(`${getApiBase()}/backgrounds/${id}`, {
    method: 'PUT',
    credentials: 'include',
    headers: jsonHeaders,
    body: JSON.stringify(body),
  }).then(json);

export const deleteBackground = (id) =>
  fetch(`${getApiBase()}/backgrounds/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  }).then(json);

export const backgroundImageUrl = (id) => `${getApiBase()}/backgrounds/${id}/image`;

// ===== Audio Tracks =====
export const listAudioTracks = () =>
  fetch(`${getApiBase()}/audio-tracks`, { credentials: 'include' }).then(json);

export const uploadAudioTrack = (file, name, visibility = 'private', durationSec) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', name || file.name);
  formData.append('visibility', visibility);
  if (durationSec != null) formData.append('duration_sec', String(durationSec));
  return fetch(`${getApiBase()}/audio-tracks`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  }).then(json);
};

export const updateAudioTrack = (id, body) =>
  fetch(`${getApiBase()}/audio-tracks/${id}`, {
    method: 'PUT',
    credentials: 'include',
    headers: jsonHeaders,
    body: JSON.stringify(body),
  }).then(json);

export const deleteAudioTrack = (id) =>
  fetch(`${getApiBase()}/audio-tracks/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  }).then(json);

export const audioTrackUrl = (id) => `${getApiBase()}/audio-tracks/${id}/audio`;

// ===== Template usage =====
export const getTemplateUsage = () =>
  fetch(`${getApiBase()}/template-usage`, { credentials: 'include' }).then(json);

export const recordTemplateUsage = (templateId) =>
  fetch(`${getApiBase()}/template-usage/${templateId}`, {
    method: 'POST',
    credentials: 'include',
  }).then(json);

// ===== User State =====
export const getUserState = () =>
  fetch(`${getApiBase()}/me/state`, { credentials: 'include' }).then(json);

export const saveUserState = (state) =>
  fetch(`${getApiBase()}/me/state`, {
    method: 'PUT',
    credentials: 'include',
    headers: jsonHeaders,
    body: JSON.stringify(state),
  }).then(json);
